import { Box, Grid, skinVars, Tabs, Tag, Text2, Text3 } from "@telefonica/mistica";
import type { TabContentProps } from ".";
import React, { useEffect, useState } from "react";
import { Center, Divider } from "@chakra-ui/react";

export const RenderTabs: React.FC<TabContentProps> = (props) => {
	const { contents, tabs, title, tagText, analytics } = props;

	const [tabIndex, setTabIndex] = useState(0);

	useEffect(() => {
		if (!analytics || !analytics[tabIndex]) {
			return;
		}

		analytics[tabIndex]();

	}, [tabIndex]);

	return (
		<>
			<Grid>
				{title && (
					<Text2 medium color={skinVars.colors.brand} textAlign="center">
						{title}
					</Text2>
				)}
			</Grid>
			{tabs?.length === 1 ? (
				<Center flexDir={"column"} pt={"16px"}>
					<Text3 medium color={"#000000"} textAlign="center">
						{tabs[0]}
					</Text3>
					<Divider width={"40%"} borderBottom="3px solid #660099" />
				</Center>
			) : tabs && (
				<Tabs
					selectedIndex={tabIndex}
					onChange={setTabIndex}
					tabs={tabs.map((text) => ({
						text,
					}))}
				/>
			)}
			<Box>
				{tagText && (
					<Box paddingBottom={16}>
						<Grid justifyContent="stretch">
							<Tag type="promo">{tagText}</Tag>
						</Grid>
					</Box>
				)}
				{contents[tabIndex]}
			</Box>
		</>
	);
};
